export default {
      id: "ic_odd_rate_change_arrow_up-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_odd_rate_change_arrow_up-usage",
      toString: function () {
        return this.url;
      }
    }